import React from 'react';
import { useTranslation } from 'react-i18next';

import { useModals } from 'hooks';

import Modal from 'components/Modal/Modal';
import { Box, Button, Text } from 'components/library';

import DoneIcon from './img/done.svg';

const AccountWasDeletedSuccessContainer = () => {
  const { t } = useTranslation();
  const { closeModal } = useModals();

  return (
    <Modal isOpen onClose={closeModal}>
      <Box $paddingTop={20} $paddingBottom={20} $paddingX={16}>
        <DoneIcon />
        <Text type="h5" bold center mb={24}>
          {t('account.settings.deleteAccount.successModal.title')}{' '}
        </Text>
        <Text type="medium-text" center mb={24}>
          {t('account.settings.deleteAccount.successModal.subTitle')}
        </Text>
        <a href={import.meta.env.VITE_WALKFIT_ONBOARDING}>
          <Button onClick={closeModal} mb={20} dataLocator="obTakeQiuz">
            {t('account.settings.deleteAccount.successModal.takeQuiz')}
          </Button>
        </a>
      </Box>
    </Modal>
  );
};

export default AccountWasDeletedSuccessContainer;
